export default "__VITE_ASSET__DmEryeMD__"